module.exports = __webpack_public_path__ + "img/flag.29ec6187.svg";